export const state = {
  //Debug logic
  debug: false,

  // Used for Redirect and loading logic
  blockAccess: true,
  cookieFound: true,
  loadingData: true,
  redirectPath: undefined,

  // Used for Logging in to Google
  authState: {googleAccessToken:undefined},

// Onboarding Setter flow
  activeStep: 0,
  disableNextStepState:[true,true,true],

//After Auth finding out what Account was selected
  accountList: undefined,
  isAccountSet: false,
  accountIndex: null,

// After Auth and Account Selection finding the Contianer
  containerList:undefined,
  isContainerSet:false,
  containerIndex: null,

// Initial Drawer state
  drawerOpen:true,

// Processed Data from GTM
  liveContainerConfig:undefined,
  tagDataTable: undefined,
  variableDataTable: undefined,
  triggerDataTable: undefined,

// Recommendation on best pratice
  recommendation:{
    folderUsage: undefined,
    reco:[]
  },

// Handing Donut Variable Names
  docDonutChart:{
    tagNames:{
      "ua":"Google Analytics Universal Analytics",
      "gaawc":"Google Analytics APP + WEB CONFIG",
      "gaawe":"Google Analytics - APP + WEB EVENT",
      "awct":"GOOGLE ADS Conversion Tracking",
      "sp":"Google Ads Remarking",
      "flc":"Floodlight Counter",
      "fls":"Floodlight Sales",
      "gclidw":"Conversion Linker",
      "opt":"Google Optimize",
      "gcs":"Google Surveys Website Satisfaction",
      "html":"Custom HTML",
      "img":"Custom Image",
      "abtGeneric":"AB Tasty Generic Tag",
      "adm":"Adometry",
      "asp":"AdRoll Smart Pixel",
      "ac360":"Audience Center 360",
      "awc":"AWIN Conversion",
      "awj":"AWIN Journey",
      "bb":"Bizrate Insights Buyer Survey Solution",
      "bsa":"Bizrate Insights Site Abandonment Survey Solution",
      "cts":"ClickTale Standard Tracking",
      "csm":"comScore",
      "cegg":"Crazy Egg",
      "crto":"Criteo OneTag",
      "dstag":"DistroScale Tag",
      "m6d":"Dstillery Universal Pixel",
      "ela":"Eulerian Analytics",
      "fxm":"FoxMetrics",
      "awcc":"Google Ads Calls from Website Conversion",
      "automl":"Recommendations AI",
      "gfct":"Google Flights Conversion Tracking",
      "gfpa":"Google Flights Price Accuracy",
      "ga":"Google Analytics Classic",
      "ts":"Google Trusted Stores",
      "hjtc":"Hotjar Tracking",
      "infinity":"Infinity Call Tracking Tag",
      "k50Init":"K50 tracking tag",
      "ll":"LeadLab",
      "bzi":"LinkedIn Insight",
      "ljs":"Lytics JS Tag",
      "ms":"Marin Software",
      "mpm":"Mediaplex - IFRAME MCT Tag",
      "mpr":"Mediaplex - Standard IMG ROI Tag",
      "baut":"Bing Ads Universal Event Tracking",
      "mf":"Mouseflow",
      "ta":"AdAdvisor",
      "ndcr":"DCR Static",
      "nudge":"Nudge Content Analytics",
      "okt":"Oktopost Tracking Code",
      "omc":"Optimise Conversion Tag",
      "messagemate":"Message Mate",
      "pa":"Perfect Audience Pixel",
      "pc":"Personali Canvas",
      "pntr":"Pinterest Tag",
      "placedPixel":"Placed",
      "pijs":"Pulse Insights Voice of Customer Platform",
      "qca":"Quantcast Advertise",
      "qcm":"Quantcast Measure",
      "qpx":"Quora Pixel",
      "scjs":"SaleCycle JavaScript Tag",
      "scp":"SaleCycle Pixel Tag",
      "sfc":"SearchForce JavaScript Tracking for Conversion Page",
      "sfr":"SearchForce Redirection Tracking",
      "sfl":"SearchForce JavaScript Tracking for Landing Page",
      "shareaholic":"Shareaholic",
      "svw":"Survicate Widget",
      "tpdpx":"Tapad Conversion Pixel",
      "tdlc":"Tradedoubler Lead Conversion",
      "tdsc":"Tradedoubler Sale Conversion",
      "tc":"Turn Conversion Tracking",
      "tdc":"Turn Data Collection",
      "twitter_website_tag":"Twitter Universal Website Tag",
      "uspt":"Upsellit Confirmation Tag",
      "uslt":"Upsellit Global Footer Tag",
      "vdc":"VisualDNA Conversion Tag",
      "xpsh":"Xtremepush - Web Push & Onsite Engagement",
      "yieldify":"Yieldify"
    },
    triggerNames:{
      "pageview":"Page Views",
      "domReady":"DOM Ready",
      "windowLoaded":"Window Loaded",
      "click":"Click",
      "linkClick":"Link Click",
      "elementVisibility":"Element Visibility",
      "formSubmission":"Form Submission",
      "scrollDepth":"Scroll Depth",
      "youTubeVideo":"YouTube Video",
      "customEvent":"Custom Event",
      "historyChange":"History Change",
      "jsError":"Javascript Error",
      "timer": "Timer",
      "triggerGroup":"Trigger Group"
    },
    variableNames:{
       "f":"HTTP Referrer",
       "u":"URL",
       "k":"1st Party Cookie",
       "jsm":"Custom Javascript",
       "v":"Data Layer Variable",
       "j":"Javascript Variable",
       "uv":"Undefined Value",
       "aev":"Auto-Event Variable",
       "d":"DOM Element",
       "vis":"Element Visibility",
       "c":"Constant",
       "e":"Custom Event",
       "ev":"Environmental Name",
       "gas":"Google Analytics Settings",
       "smm":"Lookup Table",
       "r":"Random Number",
       "remm":"Regex Table",
       "cid":"Container ID",
       "ctv":"Container Version Number",
       "dbg":"Debug Mode",
       "pageUrl":"Page URL",
       "pageHostname":"Page Hostname",
       "pagePath":"Page Path",
       "referrer":"Referrer",
       "event":"Event",
       "clickUrl":"Click URL",
       "clickText":"Click Text",
       "clickElement":"Click Element",
       "clickClasses":"Click Classes",
       "clickId":"Click Id",
       "clickTarget":"Click Target",
       "debugMode":"Debug Mode",
       "formElement":"Form Element",
       "formClasses":"Form Classes",
       "formId":"Form ID",
       "formTarget":"Form Target",
       "formUrl":"Form URL",
       "formText":"Form Text",
       "errorMessage":"Error Message",
       "errorUrl":"Error URL",
       "errorLine":"Error Line",
       "newHistoryFragment":"New History Fragment",
       "oldHistoryFragment":"Old History Fragment",
       "newHistoryState":"New History State",
       "oldHistoryState":"Old History State",
       "historySource":"History Source",
       "containerVersion":"Container Version",
       "randomNumber":"Random Number",
       "containerId":"Container Id",
       "htmlId":"HTML ID",
       "environmentName":"Environment Name",
       "videoProvider":"Video Provider",
       "videoUrl":"Video URL",
       "videoTitle":"Video Title",
       "videoDuration":"Video Duration",
       "videoPercent":"Video Percent",
       "videoVisible":"Video Visible",
       "videoStatus":"Video Status",
       "videoCurrentTime":"Video Current Time",
       "scrollDepthThreshold":"Scroll Depth Threshold",
       "scrollDepthUnits":"Scroll Depth Units",
       "scrollDepthDirection":"Scroll Direction",
       "elementVisibilityRatio":"Percent Visible",
       "elementVisibilityTime":"On-Screen Duration"
    }
  }


}

//TEMP data
/*
accountList: [{"path":"accounts/154454687","accountId":"154454687","name":"insightful tech"},{"path":"accounts/1303580524","accountId":"1303580524","name":"Above the fold"}],
accountList should be blank array

authState: {"isLogined":true,"accessToken":"","googleAccessToken":"ya29.a0AfH6SMCxmMfvONsiW-sFgO6lax1ZI39y_zA9aGyVnzZAJBNkgxRe-RvOHyfTx8j2ehs7Y0bc6YMMbghaXReZr9M4wkFjOIl_COsNRKJy7w--CdSI9bJAbSvLavn1Xuedvu_fgaBLpOPbliXm6b9sCZ_R3t_cHpo_iiM","googleRefreshToken":"1//0ejGsiCjZbn1ZCgYIARAAGA4SNwF-L9Irb4gyh_in9E1Y9i1PhVo0g11GV6GBmtYFzAfke_4dw6lwANj5VBIbk4NdOiQgfRgFEFQ","email":"george@insightful.tech","name":"George Jeng","firstName":"George","lastName":"Jeng","locale":"en","googleUserId":"100492344558990131376"},

  authState: {googleAccessToken:undefined},
*/
